export enum NavigationMixpanelEvents {
	OnwardClick = 'NAV/ONWARD_CLICK',
}
